exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notifications-email-report {\n   background-color: #f3f4f6;\n}\n", ""]);

// exports
